import { TFunction } from "i18next";
import { SWRConfiguration } from "swr";

export const enum Granularity {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
}

export const granularityOptions = (
  t: TFunction
): { id: Granularity; value: string }[] => [
  {
    id: Granularity.DAY,
    value: t("common:analytics.x_axis_option_day_label"),
  },
  {
    id: Granularity.WEEK,
    value: t("common:analytics.x_axis_option_week_label"),
  },
  {
    id: Granularity.MONTH,
    value: t("common:analytics.x_axis_option_month_label"),
  },
];

export const DEFAULT_ATTRIBUTES_SWR_CONFIG: SWRConfiguration = {
  refreshInterval: 600000, // Refresh every 10 minutes
  revalidateOnFocus: true, // Revalidate on focus only when conditions are met
  dedupingInterval: 600000, // Avoid duplicate requests within 10 minutes
};
